const ALLOWED_HOSTNAMES = new Set(["tec.editor.foris.ai", "tecpprd.editor.foris.ai", "localhost"]);

// Exclusive cutoff in the browser's local timezone: the modal is available through 2026-08-31.
const CUTOFF_EXCLUSIVE = new Date(2026, 8, 1);

interface TecPastSessionsOnboardingEligibility {
  hostname: string;
  now: Date;
  userId?: string | null;
  hasDismissed: boolean;
}

export const isTecPastSessionsOnboardingEligible = ({
  hostname,
  now,
  userId,
  hasDismissed,
}: TecPastSessionsOnboardingEligibility): boolean => {
  const normalizedHostname = hostname.trim().toLowerCase();
  const normalizedUserId = userId?.trim();

  if (!normalizedUserId || Number.isNaN(now.getTime()) || now >= CUTOFF_EXCLUSIVE) return false;
  if (!ALLOWED_HOSTNAMES.has(normalizedHostname)) return false;

  return !hasDismissed;
};
